import * as yup from 'yup';
import { VALIDATION_MESSAGES } from 'consts/validationMessages.const';
import { emailValidator } from 'consts/validators.const';

export const registrationValidationSchema = yup.object({
  email: yup.string().required(VALIDATION_MESSAGES.required).matches(emailValidator, VALIDATION_MESSAGES.email),
  password: yup.string().required(VALIDATION_MESSAGES.required),
  terms: yup.bool().oneOf([true], VALIDATION_MESSAGES.required),
});
